// src/components/ui/FormField.tsx (수정)

import React from "react";
import classNames from "classnames";

// Label 서브 컴포넌트
interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}
const Label: React.FC<LabelProps> = ({ className, children, ...props }) => {
  return (
    <label className={classNames("text-base font-medium text-text-secondary flex-shrink-0", className)} {...props}>
      {children}
    </label>
  );
};

// Input 서브 컴포넌트
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}
const Input: React.FC<InputProps> = ({ className, ...props }) => {
  return (
    <input
      className={classNames(
        "border border-solid border-ui-border-subtle rounded-[4px] pl-2 h-12 text-base outline-none",
        className
      )}
      {...props}
    />
  );
};

// 설명 텍스트를 위한 서브 컴포넌트 (확장 예시)
interface DescriptionProps extends React.HTMLAttributes<HTMLParagraphElement> {}
const Description: React.FC<DescriptionProps> = ({ className, children, ...props }) => {
  return (
    <p className={classNames("text-sm text-gray-500", className)} {...props}>
      {children}
    </p>
  );
};

// Icon을 absolute로 배치하는 컴포넌트
interface IconProps extends React.HTMLAttributes<HTMLSpanElement> {
  position?: "left" | "right";
}

const Icon: React.FC<IconProps> = ({ position = "right", className, ...props }) => (
  <span
    className={classNames(
      "absolute flex items-center",
      { "left-2 bottom-3": position === "left" },
      { "right-2 bottom-3": position === "right" },
      className
    )}
    {...props}
  />
);

interface FormFieldProps {
  children: React.ReactNode;
  direction?: "row" | "col";
  className?: string;
}

const FormField = ({ direction = "row", className, children }: FormFieldProps): JSX.Element => {
  return (
    <div
      className={classNames(
        "flex gap-2 relative",
        { "flex-row items-center": direction === "row" },
        { "flex-col": direction === "col" },
        className
      )}
    >
      {children}
    </div>
  );
};

const FormMessage = ({ children, className }: { children: React.ReactNode; className?: string }): JSX.Element => {
  return <div className={classNames(className)}>{children}</div>;
};

FormField.Label = Label;
FormField.Input = Input;
FormField.Description = Description;
FormField.Icon = Icon;
FormField.Message = FormMessage;

export default FormField;
